import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import darkTheme from './theme/theme';
import { AuthProvider } from './context/AuthContext';
import { FavoritesProvider } from './context/FavoritesContext';
import { CartProvider } from './context/CartContext';
import { PriceProvider } from './context/PriceContext';
import { GalleryReloadProvider } from './context/GalleryReloadContext';
import { ToastProvider } from './context/ToastContext';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import FavoritesPage from './pages/FavoritesPage';
import CartPage from './pages/CartPage';
import LoginPage from './pages/LoginPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentPage from './pages/PaymentPage';
import PreviewContentPage from './pages/PreviewContentPage';
import ActiveStatusProPage from './pages/ActiveStatusProPage';
import { trackPageView } from './services/analytics';
import { notifyCatalogVisit } from './services/visitNotifications';
import './App.css';

// Componente para trackear páginas
function AnalyticsTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  
  return null;
}

function App() {
  useEffect(() => {
    notifyCatalogVisit();
  }, []);

  return (
    <ThemeProvider theme={darkTheme}>
      <ToastProvider>
        <AuthProvider>
          <PriceProvider>
            <FavoritesProvider>
              <CartProvider>
                <GalleryReloadProvider>
                  <Router basename="/catalog">
                    <AnalyticsTracker />
                    <Routes>
                      {/* Rutas con Layout de Canvasoft */}
                      <Route path="/" element={<Layout><HomePage /></Layout>} />
                      <Route path="/search" element={<Layout><SearchPage /></Layout>} />
                      <Route path="/favorites" element={<Layout><FavoritesPage /></Layout>} />
                      <Route path="/cart" element={<Layout><CartPage /></Layout>} />
                      <Route path="/login" element={<Layout><LoginPage /></Layout>} />
                      <Route path="/payment" element={<Layout><PaymentPage /></Layout>} />
                      <Route path="/payment-success" element={<Layout><PaymentSuccessPage /></Layout>} />
                      <Route path="/previewcontent" element={<Layout><PreviewContentPage /></Layout>} />
                      
                      {/* Ruta sin Layout (standalone) */}
                      <Route path="/activestatuspro" element={<ActiveStatusProPage />} />
                    </Routes>
                  </Router>
                </GalleryReloadProvider>
              </CartProvider>
            </FavoritesProvider>
          </PriceProvider>
        </AuthProvider>
      </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
